export { VpAlertBigIcon } from './VpAlertBigIcon';



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpAlertBigIcon/index.js